import { emitter } from 'shared/helpers/mitt';
import analyticsHelper from 'dashboard/helper/AnalyticsHelper/index';

export { useToggle } from './useToggle';
export { useFilterData, filterData, getValueByPath } from './useFilterData';
export {
  useImageValidation,
  validateImageFile,
  buildImageValidationMessage,
} from './useImageValidation';
export { useTracking } from './useTracking';
export { useResourceQuery } from './lais/useResourceQuery';

/**
 * Custom hook to track events
 */
export const useTrack = (...args) => {
  try {
    return analyticsHelper.track(...args);
  } catch (error) {
    // Ignore this, tracking is not mission critical
  }

  return null;
};

/**
 * Emits a toast message event using a global emitter.
 * @param {string} message - The message to be displayed in the toast.
 * @param {Object|null} action - Optional callback function or object to execute.
 */
export const useAlert = (message, action = null, options = {}) => {
  emitter.emit('newToastMessage', {
    message,
    action,
    variant: options.variant || action?.variant || 'neutral',
  });
};
